import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { TMachineListActions } from './machine-list.actions';
import { TMachineListState, TMachineListInfoActionType } from './machine-list.models';

export const MACHINE_LIST_FEATURE_KEY = 'machineList';

export const intialState: TMachineListState = {
  machineListingInfo: null,
  machineListingFilterDropdown: null,
  bulkAssignLocationDropdown: null,
  siblingFactoriesDropdown: null,
  machineTransferDropdown: null,
  machineAndLineDetails: null,
  machineListingPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
  currentListingTab: 'WITH_FACTORY',
};

export function machineListReducer(state = intialState, action: TMachineListActions): TMachineListState {
  switch (action.type) {
    case TMachineListInfoActionType.SetMachineListPagination:
      return {
        ...state,
        machineListingPagination: action.pagination,
      };
    case TMachineListInfoActionType.SetMachineListingTab:
      return {
        ...state,
        currentListingTab: action.tab,
      };
    case TMachineListInfoActionType.GetMachineList:
      return {
        ...state,
        machineListingInfo: null,
      };
    case TMachineListInfoActionType.GetMachineListSuccess:
      return {
        ...state,
        machineListingInfo: {
          res: action.machineListRes,
          fetchReason: action.fetchReason,
        },
      };
    case TMachineListInfoActionType.GetMachineListFilterDropDown:
      return {
        ...state,
        machineListingFilterDropdown: null,
      };
    case TMachineListInfoActionType.GetMachineListFilterDropDownSuccess:
      return {
        ...state,
        machineListingFilterDropdown: action.machineListDropdownRes,
      };
    case TMachineListInfoActionType.GetBulkAssignLocationDropdown:
      return {
        ...state,
        bulkAssignLocationDropdown: null,
      };
    case TMachineListInfoActionType.GetBulkAssignLocationDropdownSuccess:
      return {
        ...state,
        bulkAssignLocationDropdown: action.res,
      };
    case TMachineListInfoActionType.GetSiblingFactoriesDropdown:
      return {
        ...state,
        siblingFactoriesDropdown: null,
      };
    case TMachineListInfoActionType.GetSiblingFactoriesDropdownSuccess:
      return {
        ...state,
        siblingFactoriesDropdown: action.res,
      };
    case TMachineListInfoActionType.GetMachineTransferDropdown:
      return {
        ...state,
        machineTransferDropdown: null,
      };
    case TMachineListInfoActionType.GetMachineTransferDropdownSuccess:
      return {
        ...state,
        machineTransferDropdown: action.res,
      };
    case TMachineListInfoActionType.ResetMachineAndLineDetails:
    case TMachineListInfoActionType.GetMachineAndLineDetails:
      return {
        ...state,
        machineAndLineDetails: null,
      };
    case TMachineListInfoActionType.GetMachineAndLineDetailsSuccess:
      return {
        ...state,
        machineAndLineDetails: action.res,
      };
    default:
      return state;
  }
}
